export default {
    contacts: { method: 'get', url: 'emcadmin/contacts' },
    destroy: { method: 'delete', url: 'emcadmin/contacts/{id}'},
    update: { method: 'put', url: 'emcadmin/contacts/{id}'},
    indexStatusContacts: { method: 'get', url: 'emcadmin/status-contacts' },
}
